import { ResolveFn } from '@angular/router';
import { ManagementUser } from '../../core/models/management-user.model';
import { UsersService } from '../../core/services/users.service';
import { inject } from '@angular/core';
import { LoadingService } from '../../core/services/loading.service';
import { map } from 'rxjs';

export const usersResolver: ResolveFn<ManagementUser[]> = (route, state) => {
  const loadingService = inject(LoadingService) ;
  loadingService.start() ;

  return inject(UsersService).getSchoolUsers().pipe(
    map((users) => {
      loadingService.finish();
      return users;
    })
  ) ;
};
